import script from "./Transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./Transfer.vue?vue&type=script&setup=true&lang=js"

import "./Transfer.vue?vue&type=style&index=0&id=e07911be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e07911be"]])

export default __exports__